const isCommaSeparatedList = (input?: string | null): boolean => {
  if (!input) {
    return false;
  }

  const cleanedText = input.trim().replace('\n', '').replace(/\s\s+/g, ' ');
  const splitedBySpaceAndComma = cleanedText.split(' ').reduce<Array<string>>((acc, value) => (
    [...acc, ...value.split(',').filter(v => v)]
  ), []);

  if (splitedBySpaceAndComma.length > cleanedText.split(',').length) {
    return false;
  }

  return true;
};

export default isCommaSeparatedList;
